import Loadable from "../../react-loadable";
import { HelpType } from './types';

const Help = Loadable({ name: 'Help', loader: () => import(/* webpackChunkName: 'ui_commont' */ "./Help") }) as HelpType;

export type { HelpProps } from "./types";
export default Help;
